export default __webpack_public_path__ + "static/media/banner-resp.2e66e287.png";